/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{createDehydratedPoint as t}from"../../../sketch/normalizedPoint.js";class o{constructor(o,r,s,i){this.objectId=o,this.layer=r,this.targetPoint=t(s,i)}}export{o as DehydratedVertexSnappingCandidate};
